import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { CharterFilingService } from '@wealthlane/api-services/wealthlane-captable-service';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '@wealthlane/api-services/wealthlane-captable-service';
import ToastComponent from '../../components/toast';

const usePostFileInitialCharter = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal?: () => void
): UseMutationResult<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined, unknown, any> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        CharterFilingService.postApiCapTableApiAppCharterFilingFileInitialCharter(payload)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          await queryClient.invalidateQueries('getCharterFilings');
          await queryClient.invalidateQueries('getStockClassList');
          await queryClient.invalidateQueries('getCharterStockClassList');
          closeModal?.();
          toast.success(<ToastComponent label='Success' message='Initial charter filed successfully.' />);
        }
      },
    }
  );
};

export default usePostFileInitialCharter;
